module.exports = __webpack_public_path__ + "light-on-light@2x.png?16b7b8956eac042da4cdfd41c718f470";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stripe/light-on-light@2x.png
// module id = 759
// module chunks = 0